// Catalog.js
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

export default function Catalog() {
  return (
    <View style={styles.container}>
      <Text>Catalog Page</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});